import React, {Component} from 'react';
import PropTypes from 'prop-types';
import RubricaSearchTableRow from './RubricaSearchTableRow'
import TablePager from '../TablePager'
import TableColumnOrdered from '../TableColumnOrdered'

class RubricaSearchTable extends Component {
    constructor(props) {
        super(props);
        let rv = this.updateData(props.count, props.rowperpage);
        this.state = {
            pages: rv.pages,
            firstPage: 1,
            lastPage: rv.lastPage,
        };

        this.onChangePage = this.onChangePage.bind(this);
    }


    componentWillReceiveProps(nextProps) {
        let rv = this.updateData(nextProps.count, nextProps.rowperpage);
        this.setState(rv);
    }

    updateData(count, rowperpage){
        let lastPage = Math.ceil(count / rowperpage);
        let pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(i);
        }
        return {pages, lastPage}
    }

    onChangePage(newpage) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.state.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                }
                break;
            case "N":
                if (this.props.page < this.state.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                }
                break;
            default:
                if (this.props.page !== newpage){
                    this.props.onChangePage(newpage);
                }
                break;
        }
    }

    onExportClick(tipo){
        if (this.props.onExportRubrica !== undefined){
            this.props.onExportRubrica(tipo)
        }
    }

    onPdfExportClick(tipo){
        if (this.props.onExportRubricaPdf !== undefined){
            this.props.onExportRubricaPdf(tipo)
        }
    }

    render() {
        return (<table className="ui striped sortable compact celled table">
            <thead>
            <tr><th colSpan="4">
                <TablePager
                    pages={this.state.pages} page={this.props.page}
                    firstPage={this.state.firstPage} lastPage={this.state.lastPage}
                    onChangePage={this.onChangePage}
                />
            </th>
            </tr>
            <tr>
                <TableColumnOrdered
                    className="five wide"
                    name="soggetto"
                    orderActive={this.props.tableOrderingField === "soggetto"}
                    orderFields="s.cognome,s.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Soggetto</TableColumnOrdered>
                <TableColumnOrdered
                    className="three wide"
                    name="dipartimento"
                    orderActive={this.props.tableOrderingField === "dipartimento"}
                    orderFields="d.nome,s.cognome,s.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Dipartimento</TableColumnOrdered>
                <TableColumnOrdered
                    className="three wide"
                    name="organizzazione"
                    orderActive={this.props.tableOrderingField === "organizzazione"}
                    orderFields="o.nome,d.nome,s.cognome,s.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Organizzazione</TableColumnOrdered>

                <th className="one wide no-print"></th>
            </tr>
            </thead>
            <tbody>
            {this.props.items.map((item) => (
                <RubricaSearchTableRow
                    item={item}
                    key={item.idSoggetto}
                    onSelectSoggetto={this.props.onSelectSoggetto} />
            ))}
            </tbody>
            <tfoot>
            </tfoot>
        </table>)
    }

}

RubricaSearchTable.PropTypes = {
    items: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onSelectSoggetto: PropTypes.func
}
export default RubricaSearchTable;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaSearchTable.js
 **/